import React, { useEffect, useState } from "react";
import "./AddWalletProceed.css";
// import CreditCardIcon from "@mui/icons-material/CreditCard";
// import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";

import { Button, Radio, RadioGroup, FormControlLabel } from "@mui/material";
import { useAuth } from "../../../Store/AuthContext";

import NotifyMessageNoReload from "../../Others/NotifyMessageNoReload";
import axios from "axios";
import { useNavigate } from "react-router-dom";
// import APIDataFetchLoader from "../../Others/APIDataFetchLoader";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";

export default function AddWalletProceed({ amount, handleWalletProceedBack }) {
  const { userID, RendomTokenfetch, profileData, userRoll } = useAuth();
  // console.log(profileData);
  const navigate = useNavigate();
  const [paymentMethod, setPaymentMethod] = useState("");
  const [PaymentMode, setPaymentMode] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);

  const safeRechargeAmount = Number(amount) || 0;
  const totalAmount = safeRechargeAmount;

  const handlePaymentMethodChange = (event) => {
    setPaymentMethod(event.target.value);
  };

  // console.log(PaymentMode);
  // *********Fetch paymentMethod********
  useEffect(() => {
    let fdata = new FormData();
    fdata.append("user_id", userID);
    const FetchVendorStatusData = async () => {
      try {
        await axios
          .post(`${WebsiteAPIurl}payment_mode`, fdata, {
            headers: {
              Authorization: RendomTokenfetch,
            },
          })
          .then((response) => {
            // console.log("API Response:", response.data);
            if (response.data.Status === "1") {
              setPaymentMode(response.data.payment_mode || []);
            }
            if (response.data.Status === "0") {
              setPaymentMode([]);
            }
          });
      } catch (err) {
        console.log(err.message);
      } finally {
      }
    };
    FetchVendorStatusData();
  }, [RendomTokenfetch, userID]);

  // **************Handle Payment Submit************
  const handlePaymentSubmit = async (event) => {
    event.preventDefault();
    if (
      !profileData.address ||
      !profileData.email ||
      !profileData.number ||
      !profileData.username
    ) {
      NotifyMessageNoReload("Please Update Your Profile!", "danger");

      setTimeout(() => {
        navigate("/profile-edit", {
          state: { returnTo: "/add-wallet" },
        });
      }, 1000);
      return;
    }

    setIsProcessing(true);
    try {
      let fdata = new FormData();
      fdata.append("userid", userID);
      fdata.append("amount", amount);
      fdata.append("userroll", userRoll);
      fdata.append("getwayMethod", paymentMethod);

      axios
        .post(`${WebsiteAPIurl}walletaddamountuser`, fdata, {
          headers: {
            Authorization: RendomTokenfetch,
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (paymentMethod && amount && userID) {
            if (response.data.status === "1") {
              // console.log(response.data);
              const htmlForm = response?.data?.Payemntcode || response.data;
              const div = document.createElement("div");
              div.innerHTML = htmlForm;
              document.body.appendChild(div);

              const form = div.querySelector("form");
              if (form) {
                form.submit();
              } else {
                throw new Error("Payment form not found in response.");
              }
              // NotifyMessageNoReload(response.data.message, "success");
            } else {
              NotifyMessageNoReload(response.data.message, "danger");
            }
          } else {
            NotifyMessageNoReload("Please Select A Payment Getway!", "danger");
          }
        });
    } catch (error) {
      NotifyMessageNoReload("Payment failed. Please try again.", "danger");
      throw error;
    } finally {
      setIsProcessing(false);
    }
  };

  // if (isProcessing) {
  //   return <APIDataFetchLoader />;
  // }
  return (
    <>
      <div
        className="newspapermultyupdatebox"
        style={{ borderBottom: "unset" }}
      >
        <div className="row my-1">
          <div className="col-lg-12 col-md-12  mt-1">
            <button
              onClick={handleWalletProceedBack}
              className="DefaultHoverbtn handleServiceStatus"
            >
              <span>
                <i className="fa fa-arrow-left me-2"></i>
              </span>{" "}
              Back
            </button>
          </div>
        </div>
      </div>
      <div className="payment-details-container">
        <div className="payment-details-card">
          <h2 className="payment-title">Payment Details</h2>

          <div className="amount-details">
            {/* <div className="amount-row">
              <span>Add Wallet Amount</span>
              <span className="amount-value">
                ₹{safeRechargeAmount.toFixed(2)}
              </span>
            </div> */}

            <div className="amount-row total ">
              <span>Total Amount</span>
              <span className="amount-value">₹{totalAmount.toFixed(2)}</span>
            </div>
          </div>
          <div className="payment-methods">
            <h3 className="section-title">Payment Method</h3>
            <RadioGroup
              value={paymentMethod}
              onChange={handlePaymentMethodChange}
            >
              {/* <FormControlLabel
                value="card"
                control={<Radio color="primary" />}
                label={
                  <div className="payment-method">
                    <CreditCardIcon className="method-icon" />
                    <span>Credit/Debit Card</span>
                  </div>
                }
              />
              <FormControlLabel
                value="netbanking"
                control={<Radio color="primary" />}
                label={
                  <div className="payment-method">
                    <AccountBalanceIcon className="method-icon" />
                    <span>Net Banking</span>
                  </div>
                }
              />
              <FormControlLabel
                value="wallet"
                control={<Radio color="primary" />}
                label={
                  <div className="payment-method">
                    <AccountBalanceWalletIcon className="method-icon" />
                    <span>Other Wallets</span>
                  </div>
                }
              /> */}

              {PaymentMode &&
                PaymentMode.length > 0 &&
                PaymentMode.map((val, index) => (
                  <FormControlLabel
                    key={index}
                    value={val.id}
                    // value={val.payment_getway}
                    control={<Radio color="primary" />}
                    label={
                      <div className="payment-method">
                        <AccountBalanceWalletIcon className="method-icon" />
                        <span>{val.payment_mode} Payment Gateway</span>
                      </div>
                    }
                  />
                ))}
            </RadioGroup>
          </div>

          <Button
            fullWidth
            variant="contained"
            color="primary"
            className="pay-now-button"
            onClick={handlePaymentSubmit}
            size="large"
            disabled={isProcessing}
          >
            {isProcessing
              ? "Processing..."
              : `Pay Now ₹${totalAmount.toFixed(2)}`}
          </Button>
        </div>
      </div>
    </>
  );
}
